import { renderCustomColumnDefs } from "../../../../shared/Table/table.utils";
import { formatDate, renderAmount } from "../../../../utils";

// Config for Job report table
const tableConfig = [
  {
    id: "jobId",
    header: "Job ID",
    cell: ({ getValue }) => getValue() || "-",
  },
  {
    id: "appointmentDate",
    header: "Appointment Date",
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) return "-";
      return formatDate(value);
    },
  },
  {
    id: "loadNumber",
    header: "Load Number",
    cell: ({ getValue }) => getValue() || "-",
  },
  {
    id: "client",
    header: "Client",
    cell: ({ getValue }) => {
      const client = getValue();
      if (!client) return "-";
      if (typeof client === "string") return client;
      return client?.name || client?.fullName || "-";
    },
  },
  {
    id: "status",
    header: "Status",
    cell: ({ getValue }) => getValue() || "-",
  },
  {
    id: "hourlyTotal",
    header: "Labor Total",
    cell: ({ getValue }) => renderAmount(getValue()),
  },
  {
    id: "partsTotal",
    header: "Parts Total",
    cell: ({ getValue }) => renderAmount(getValue()),
  },
  {
    id: "serviceFeeTotal",
    header: "Service Fee",
    cell: ({ getValue }) => renderAmount(getValue()),
  },
  {
    id: "calculatedTotalCharges",
    header: "Gross",
    cell: ({ getValue }) => renderAmount(getValue()),
  },
];

export const COLUMN_DEFINITIONS = renderCustomColumnDefs(tableConfig);
